// removed by extract-text-webpack-plugin
module.exports = {"image":"nFerz","large":"CAPYM","extraLarge":"_9SCgh","promote":"_3ZZAW","member":"_2YKcv","widget":"_3ddMG","comment":"HWieH","commentSearch":"_3setc"};


//////////////////
// WEBPACK FOOTER
// ./app/components/avatar-image/avatar-image.scss
// module id = 828
// module chunks = 3 4 5 6 7